import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import useAsync from "hooks/useAsync";
import useToast from "hooks/useToast";
import deleteHYManagerService from "services/hy/deleteHYManagerService";
import Alert from "components/Alert";
import Button from "components/Button";

function DeleteHYManager({ manager, onDelete }) {
  const { showSuccess, showError } = useToast();
  const [alertVisible, setAlertVisible] = React.useState(false);

  const [fetch, pending] = useAsync({
    promiseFn: deleteHYManagerService,
    onError: (error) => {
      showError("Error deleting Manager");
    },
    onData: () => {
      showSuccess("Manager deleted successfully.");
      onDelete();
    },
  });

  return (
    <>
      <Button
        size="sm"
        icon="trash"
        onClick={() => setAlertVisible(true)}
        loading={pending}
      />
      <Alert
        isOpen={alertVisible}
        onConfirm={() => fetch({ id: manager.manager_id.entity_id })}
        intent="danger"
        icon="trash"
        onCancel={() => setAlertVisible(false)}
      >
        Are you sure you want to delete the Manager{" "}
        <b>{get(manager, "manager_id.long_name", "")}</b>?
      </Alert>
    </>
  );
}

DeleteHYManager.propTypes = {
  manager: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
};

DeleteHYManager.defaultProps = {
  manager: {},
};

export default DeleteHYManager;
